import React from "react";

export default function AdvancedTechnology() {
  return <div>AdvancedTechnology</div>;
}
